import { useTranslation } from 'react-i18next';
import MasterLayout from '../components/layouts/MasterLayout';
import MainSearch from '../components/search/MainSearch';
import LatestVersionModal from "../components/modal/LatestVersionModal";
import Banner from "../components/banner/Banner";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { CLEAR_PRODUCT_LIST, CLEAR_SHOW_MORE_PRODUCT_LIST, FETCH_PRODUCT_LIST, FETCH_SHOW_MORE_PRODUCT_LIST } from "../redux/actions";
import ProductsList from "../components/products/ProductsList";
import { useDebounce } from '../helpers';
import ShowMoreProductList from '../components/products/ShowMoreProductList';

const ProductPage = () => {
    const { t } = useTranslation();


    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const { productData } = state.productData;
    const { freeCheckbox } = state;
    const selectedId = state.selectItemDrawerMenu.selectedId;
    const { selectSpace } = state.selectSpace
    const { selectColor } = state.selectColor
    const { searchInputContent } = state.searchInputContent
    const currentPage = state.currentPage.currentPage;
    const { showmoreStatusCode } = state.showmoreStatusCode
    const { showMoreProductData } = state.showMoreProductData;


    const debouncedSearchContent = useDebounce(searchInputContent, 500);

    useEffect(() => {
        if (showmoreStatusCode === 303) {
            dispatch({ type: CLEAR_PRODUCT_LIST });
            dispatch({ type: CLEAR_SHOW_MORE_PRODUCT_LIST });
            dispatch({ type: FETCH_SHOW_MORE_PRODUCT_LIST });
        }
    }, [freeCheckbox, selectSpace, selectColor, debouncedSearchContent, currentPage]);


    useEffect(() => {
        dispatch({ type: FETCH_PRODUCT_LIST });
    }, [freeCheckbox, selectSpace, selectColor, debouncedSearchContent])

    return (
        <MasterLayout>
            <LatestVersionModal />
            <MainSearch />
            <>
                <Banner />
                {
                    showmoreStatusCode === 303 ?
                        <ShowMoreProductList data={showMoreProductData} status={'product'} />
                        :
                        <ProductsList products={productData} showMoreStatus={showmoreStatusCode} />
                }
            </>

        </MasterLayout>

    );
};

export default ProductPage;
